<template>
  <div v-if="store.firstRequiredItem" class="product-variant-picker">
    <div
      v-if="$textDictionary['pdp.configuration.title.label']"
      class="product-variant-picker__title"
    >
      <span>
        {{ $textDictionary['pdp.configuration.title.label'] }}
      </span>
    </div>
    <div class="product-variant-picker__items">
      <div
        v-for="optionGroup in options"
        :key="optionGroup.code!"
        class="product-variant-picker__item"
      >
        <div class="product-variant-picker__option-groups">
          <ProductVariantPickerOptionGroup
            v-bind="optionGroup"
            @update="(newValue: string) => store.selectOption(optionGroup.code!, newValue)"
          />
        </div>
      </div>
    </div>
  </div>

  <div v-if="store.items.length > 0" class="product-variant-picker">
    <div
      v-if="$textDictionary['pdp.addons.title.label']"
      class="product-variant-picker__title"
    >
      <span>
        {{ $textDictionary['pdp.addons.title.label'] }}
      </span>
    </div>
    <div class="product-variant-picker__items">
      <div
        v-for="item in store.items"
        :key="item.id"
        class="product-variant-picker__item"
      >
        <ProductVariantPickerSelect
          v-bind="item"
          @update:model-value="(value) => store.selectOption(item.id, value)"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ProductVariantPickerOptionGroup,
  ProductVariantPickerSelect
} from '@hypercodestudio/basler-components';
import type { Props as VariantOptionProps } from '@hypercodestudio/basler-components/dist/components/modules/ProductVariantPickerOption.vue';
import { useProductAddonsStore } from '~/stores/productDetailPageStore/productAddonsStore';
import { isDefined } from '~/utils/guards/isDefined';
import { formatMoney } from '~/utils/shop/formatMoney';

const { $textDictionary, $locale } = useNuxtApp();
const store = useProductAddonsStore();

const options = computed(() => {
  const firstRequiredItem = store.firstRequiredItem;
  if (!firstRequiredItem) {
    return [];
  }

  return [
    {
      code: firstRequiredItem.uid ?? '',
      title: firstRequiredItem.title ?? '',
      options:
        firstRequiredItem.options?.filter(isDefined).map<VariantOptionProps>(
          (option) =>
            ({
              // TODO: check if we can avoid setting targetUrl and use a button
              //  instead of an A tag
              link: {
                uri: 'javascript:;'
              },
              id: option.uid ?? '',
              label: option.label ?? '',
              value: option.uid ?? '',
              isActive:
                store.selectedRequiredItemUrlKey === option.product?.url_key,
              subtitle: formatMoney(
                option.product?.price_range?.minimum_price?.final_price,
                $locale.value
              )
            } satisfies VariantOptionProps)
        ) ?? []
    }
  ];
});
</script>
